import React, { useState, useEffect } from "react";
import Main from "../main/Main";
import SideHeader from "../sideheader/SideHeader";
import Navbar from "../navbar/Navbar";

const Layout = () => {
  const [activeSection, setActiveSection] = useState("home");

  useEffect(() => {
    const sections = document.querySelectorAll("section[id]");
    if (sections.length === 0) return;

    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries
          .filter((e) => e.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio);
        if (visible.length > 0) {
          setActiveSection(visible[0].target.id);
        }
      },
      { threshold: 0, rootMargin: "-45% 0px -45% 0px" }
    );

    sections.forEach((section) => observer.observe(section));
    return () => observer.disconnect();
  }, []);

  return (
    <>
      <a href="#home" className="skip-link">
        Skip to content
      </a>
      <SideHeader activeSection={activeSection} />
      <Navbar activeSection={activeSection} />
      <Main />
    </>
  );
};

export default Layout;
